// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.syncing-progress {
  min-height: calc(100vh - 140px);
  padding: 40px;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.syncing-header {
  text-align: center;
  margin-bottom: 60px;
}

.syncing-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
}

.syncing-animation {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin-bottom: 60px;
}

.sync-container {
  display: flex;
  align-items: center;
  gap: 60px;
}

.platform-logo img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.sync-arrows {
  position: relative;
}

.arrow-circle {
  width: 120px;
  height: 120px;
  /* border: 2px solid #e5e7eb; */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  /* animation: pulse 2s infinite; */
}

.arrow-top,
.arrow-bottom {
  position: absolute;
  color: #3b82f6;
}

.arrow-top {
  top: 20px;
  animation: moveRight 1.5s infinite;
}

.arrow-bottom {
  bottom: 20px;
  animation: moveLeft 1.5s infinite;
}

@keyframes pulse {
  0%,
  100% {
    border-color: #e5e7eb;
  }
  50% {
    border-color: #3b82f6;
  }
}

@keyframes moveRight {
  0%,
  100% {
    transform: translateX(-10px);
    opacity: 0.5;
  }
  50% {
    transform: translateX(10px);
    opacity: 1;
  }
}

@keyframes moveLeft {
  0%,
  100% {
    transform: translateX(10px);
    opacity: 0.5;
  }
  50% {
    transform: translateX(-10px);
    opacity: 1;
  }
}

.progress-indicator {
  text-align: center;
  min-width: 300px;
}

.progress-text {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 16px;
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #10b981);
  border-radius: 4px;
  transition: width 0.5s ease;
}

.syncing-actions {
  text-align: center;
}

.go-home-button {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.go-home-button:hover:not(:disabled) {
  background: #2563eb;
}

.go-home-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .syncing-progress {
    padding: 20px;
  }

  .sync-container {
    gap: 30px;
  }

  .platform-logo img {
    width: 60px;
    height: 60px;
  }

  .arrow-circle {
    width: 80px;
    height: 80px;
  }

  .arrow-top,
  .arrow-bottom {
    width: 40px;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/components/SyncingProgress.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE;;IAEE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,4BAA4B;IAC5B,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".syncing-progress {\n  min-height: calc(100vh - 140px);\n  padding: 40px;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.syncing-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.syncing-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.syncing-animation {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 40px;\n  margin-bottom: 60px;\n}\n\n.sync-container {\n  display: flex;\n  align-items: center;\n  gap: 60px;\n}\n\n.platform-logo img {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n}\n\n.sync-arrows {\n  position: relative;\n}\n\n.arrow-circle {\n  width: 120px;\n  height: 120px;\n  /* border: 2px solid #e5e7eb; */\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  /* animation: pulse 2s infinite; */\n}\n\n.arrow-top,\n.arrow-bottom {\n  position: absolute;\n  color: #3b82f6;\n}\n\n.arrow-top {\n  top: 20px;\n  animation: moveRight 1.5s infinite;\n}\n\n.arrow-bottom {\n  bottom: 20px;\n  animation: moveLeft 1.5s infinite;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    border-color: #e5e7eb;\n  }\n  50% {\n    border-color: #3b82f6;\n  }\n}\n\n@keyframes moveRight {\n  0%,\n  100% {\n    transform: translateX(-10px);\n    opacity: 0.5;\n  }\n  50% {\n    transform: translateX(10px);\n    opacity: 1;\n  }\n}\n\n@keyframes moveLeft {\n  0%,\n  100% {\n    transform: translateX(10px);\n    opacity: 0.5;\n  }\n  50% {\n    transform: translateX(-10px);\n    opacity: 1;\n  }\n}\n\n.progress-indicator {\n  text-align: center;\n  min-width: 300px;\n}\n\n.progress-text {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 16px;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #e5e7eb;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #10b981);\n  border-radius: 4px;\n  transition: width 0.5s ease;\n}\n\n.syncing-actions {\n  text-align: center;\n}\n\n.go-home-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.go-home-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.go-home-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .syncing-progress {\n    padding: 20px;\n  }\n\n  .sync-container {\n    gap: 30px;\n  }\n\n  .platform-logo img {\n    width: 60px;\n    height: 60px;\n  }\n\n  .arrow-circle {\n    width: 80px;\n    height: 80px;\n  }\n\n  .arrow-top,\n  .arrow-bottom {\n    width: 40px;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
